import { useMemo } from "react";
import { useSelector } from "react-redux";
import { isDoctor } from "domain/User.model";

/**
 * Hook to determine if the current user is a doctor.
 *
 * @returns {boolean} - Returns true if the user is a doctor, false otherwise.
 */
export const useIsDoctor = () => {
    const user = useSelector((state) => state.mainReducer.user);
    return useMemo(() => isDoctor(user), [user]);
}
